'use client'

import React from 'react'
import { Wifi, WifiOff } from 'lucide-react'
import { cn } from '@/lib/utils'

import { Indicator } from '@/components/ui/indicator'

export const NetworkIndicator = () => {
  const [isOnline, setIsOnline] = React.useState(false)

  React.useEffect(() => {
    const setStatus = () => {
      if (navigator && navigator?.onLine) {
        setIsOnline(true)
      } else {
        setIsOnline(false)
      }
    }

    setStatus()

    window.addEventListener('online', setStatus)
    window.addEventListener('offline', setStatus)

    return () => {
      window.removeEventListener('online', setStatus)
      window.removeEventListener('offline', setStatus)
    }
  }, [])

  return (
    <div className={cn('flex items-center gap-1.5')}>
      <Indicator variant={isOnline ? 'success' : 'default'} />
      {isOnline ? (
        <Wifi size={18} strokeWidth={2} />
      ) : (
        <WifiOff size={18} strokeWidth={2} />
      )}
    </div>
  )
}

NetworkIndicator.displayName = 'NetworkIndicator'
